#import "./fragments/personFragment.graphql"
#import "./fragments/teamFragment.graphql"
#import "./fragments/tagFragment.graphql"

query globalSearchQuery(
  $searchTerms: [String]
  $size: Int
  $filter: InsightFilter
  $includePeople: Boolean! = true
  $includeGroups: Boolean! = true
  $includeTags: Boolean! = false
  $personFieldsToSearch: [PersonFieldsToSearch]
  $groupFieldsToSearch: [GroupFieldsToSearch]
  $tagFieldsToSearch: [TagFieldsToSearch]
  $personSearchAfterId: [String]
  $tagsOffset: Int = 0
  $groupsOffset: Int = 0
  $includeEmptyGroups: Boolean = false
) {
  result: globalSearch(
    tagsOffset: $tagsOffset
    groupsOffset: $groupsOffset
    size: $size
    searchTerms: $searchTerms
    filter: $filter
    personFieldsToSearch: $personFieldsToSearch
    groupFieldsToSearch: $groupFieldsToSearch
    tagFieldsToSearch: $tagFieldsToSearch
    personSearchAfterId: $personSearchAfterId
    includeTags: $includeTags
    includePeople: $includePeople
    includeGroups: $includeGroups
    includeEmptyGroups: $includeEmptyGroups
  ) {
    pagedPeople @include(if: $includePeople) {
      totalCount
      searchAfterId
      people {
        ...GlobalSearchPersonBaseFragment
        __typename
      }
      __typename
    }

    pagedGroups @include(if: $includeGroups) {
      totalCount
      groups {
        ...TeamFragment
        __typename
      }
      __typename
    }

    pagedTags @include(if: $includeTags) {
      totalCount
      tags {
        ...TagMinimalFragment
        __typename
      }
      __typename
    }
  }
}
